import api from './axiosConfig';

export type OffhoursProxyHistoryPoint = {
  at: string;
  price: number | null;
};

export type OffhoursProxyHistorySeries = {
  providerSymbol: string;
  underlyingCode: string;
  displayName: string;
  marketRole: string;
  instrumentType: string;
  windowAnchorChangePct: number | null;
  points: OffhoursProxyHistoryPoint[];
};

export type OffhoursProxyHistoryResponse = {
  mode: 'ACTIVE' | 'SHADOW' | 'SUPPRESSED' | string;
  displayEligible: boolean;
  stateReason?: string;
  windowKey?: string | null;
  generatedAt?: string;
  historyMinutes?: number;
  series: OffhoursProxyHistorySeries[];
};

export async function getOffhoursMarketProxyHistory(
    timeoutMs = 5_000,
): Promise<OffhoursProxyHistoryResponse> {
  const response = await api.get<OffhoursProxyHistoryResponse>(
      '/live-summary/offhours-proxy/history',
      {
        timeout: timeoutMs,
        withCredentials: true,
      },
  );
  return response.data;
}
